{
  "currentBid": "Current bid",
  "startingBid": "Starting bid",
  "startingPrice": "Starting price",
  "buyNow": "Buy It Now",
  "buyNowUnavailable": "Buy It Now is no longer available because bidding has started.",
  "reserveMet": "Reserve met",
  "reserveNotMet": "Reserve not yet met",
  "reserveNotMetTitle": "Reserve Not Met",
  "reserveNotMetBody": "The highest bid did not reach the seller's reserve price. No winner was declared and no order was created.",
  "noReserve": "No reserve",
  "reservePrice": "Reserve price",
  "minimumIncrement": "Minimum increment",
  "minimumBid": "Minimum bid is {amount}",
  "yourBid": "Your bid (min {amount})",
  "endsIn": "Auction ends in",
  "timeRemaining": "Time remaining",
  "auctionEnds": "Auction ends",
  "ended": "Ended",
  "auctionEnded": "This auction has ended.",
  "auctionEndedSold": "This auction has ended and been sold.",
  "youWon": "🎉 You won this auction!",
  "autoExtendEnabled": "Auto-extend enabled",
  "autoExtended": "Auction extended by {seconds} seconds",
  "placeBid": "Place bid",
  "signInToBid": "Sign in to bid",
  "ownAuction": "You can't bid on your own auction.",
  "biddingPaused": "Another buyer is completing a Buy It Now checkout. Bidding is paused for up to 10 minutes.",
  "bidHistory": "Bid history",
  "winningBid": "Winning bid",
  "highestBidder": "Highest bidder",
  "youAreWinning": "You are the highest bidder",
  "outbid": "Outbid",
  "sold": "Sold",
  "paymentPending": "Payment pending",
  "payNow": "Pay now",
  "preparingPayment": "Preparing payment…",
  "preparePayment": "Prepare payment",
  "viewOrder": "View order",
  "loadingOrder": "Loading your order…",
  "disputeHold": "A dispute is active on this order — payment is on hold.",
  "promoteListing": "Promote listing",
  "bids": "{count, plural, one {# bid} other {# bids}}",
  "watchers": "{count, plural, one {# watcher} other {# watchers}}",
  "yourMaxBid": "Your maximum bid",
  "bidPlaced": "Bid placed",
  "invalidAmount": "Enter a valid amount",
  "bidTooLow": "Your bid must be at least {amount}.",
  "shipping": "Shipping",
  "collection": "Collection",
  "payment": "Payment",
  "seller": "Seller",
  "buyer": "Buyer",
  "condition": "Condition",
  "grade": "Grade",
  "population": "Population",
  "certificateNumber": "Certificate number",
  "watchlist": "Watchlist",
  "addToWatchlist": "Add to watchlist",
  "removeFromWatchlist": "Remove from watchlist"
}
